import axios from 'axios';
import moment from 'moment';
export const SCREEN_CODE_LENGTH = 6;
// Codes are printed as "K7Q-42M"; the API ignores case, dashes and spaces
export const normalizeCode = (value) => (value || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, SCREEN_CODE_LENGTH);
export const formatCode = (code) => {
    const normalized = normalizeCode(code);
    return normalized.length > 3 ? `${normalized.slice(0, 3)}-${normalized.slice(3)}` : normalized;
};
export const formatEventLabel = ({ name, date }) => {
    const parsed = date ? moment(date, ['DD.MM.YYYY', 'YYYY-MM-DD'], true) : null;
    const dateLabel = (parsed === null || parsed === void 0 ? void 0 : parsed.isValid()) ? parsed.format('DD.MM.YYYY') : date;
    return [dateLabel, name].filter(Boolean).join(' · ');
};
export const formatTime = (unix) => {
    const time = moment.unix(unix);
    return time.isSame(moment(), 'day') ? time.format('HH:mm') : time.format('DD.MM HH:mm');
};
// Pair errors shown next to the code input instead of the global alert
export const getPairErrorMessage = (err) => {
    if (!axios.isAxiosError(err) || !err.response)
        return null;
    const { status, data } = err.response;
    if (status === 404)
        return (data === null || data === void 0 ? void 0 : data.message) || 'Код не найден или устарел';
    if (status === 400 && data && typeof data === 'object') {
        const first = Object.values(data)[0];
        return (Array.isArray(first) ? first[0] : first) || 'Проверьте код экрана';
    }
    return null;
};
